module.exports = __webpack_public_path__ + "img/img_about_2.79d85260.jpg";